
    import { defineComponent } from 'vue'

    import { useSharedSettingsStore } from '@/common/stores/shared-settings'

    export default defineComponent({
        setup () {
            return {
                contactMail: useSharedSettingsStore().setting('contact-mail')
            }
        }
    })
